import angular from 'angular';

const componentOptions = {
    bindings: {
        model: '=',
        modules: '=',
        selected: '=',
        available: '=',
        quantity: '=',
        view: '=',
        dataequalrow: '=',
        index: '=',
        last: '='
    },
    controllerAs: 'ancCompsCtrl',
    templateUrl: [
        '$rootScope', function ($rootScope) {
            return $rootScope.routes.templates + 'ib-ancillaries-components.html';
        }]
};


const componentInfo = {
    module: 'ib-ancillaries-components',
    selector: 'ibAncillariesComponents',
    inject: ['$scope', '$window', 'DatalayerUtilsService', 'AncillariesConstants', 'localStorageService', '$rootScope'],
    required: ['']
};


export class ibAncillariesComponents implements ng.IController {
    public model;
    public isBlocked = false;
    constructor (
        private $scope: angular.IScope,
        private $window: ng.IWindowService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private AncillariesConstants: AncillariesConstant,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $rootScope: CommonsRootScope) {

        this.$scope.$on('lockItemsFromBundle', this.lockItemForBundle);
        this.$scope.$on('unlockItemsFromBundle', this.unlockItemForBundle);
    }

    $onInit (): void {
        this.lockItemForBundle();
    }

    /*
    * Change button if is selected in bundle
    *
    */
    lockItemForBundle = () => {
        const selectedBundle: any = this.localStorageService.get('selectedBundle');
        if(selectedBundle) {
            selectedBundle.items.forEach(item => {
                switch(item.type) {
                        case 'FLEXIBILITY_ON_DEMAND':
                            if(this.model.name === 'requestFlex') {
                                this.isBlocked = true;
                            }
                            break;
                        case 'PRIORITY_BOARDING':
                            if(this.model.name === 'priorityBoarding') {
                                this.isBlocked = true;
                            }
                            break;
                }
            });
        }
    };

    /*
    * Change button if is selected in bundle
    *
    */
    unlockItemForBundle = () => {
        this.isBlocked = false;
        this.$rootScope.$broadcast('changeButtonStyleBundle');
    };

    callback = (name: any): void => {
        let ancillarieBlockedByBundle: boolean = false;
        const selectedBundle: any = this.localStorageService.get('selectedBundle');
        if(selectedBundle && selectedBundle.items) {
            for(let i = 0; i < selectedBundle.items.length; i++) {
                switch(selectedBundle.items[i].type) {
                        case 'FLEXIBILITY_ON_DEMAND':
                            if(name === 'requestFlex') {
                                ancillarieBlockedByBundle = true;
                            }
                            break;
                        case 'PRIORITY_BOARDING':
                            if(name === 'priorityBoarding') {
                                ancillarieBlockedByBundle = true;
                            }
                            break;
                }
            }
        }
        if(!ancillarieBlockedByBundle) {
            this.DatalayerUtilsService.updateDatalayerActionForAncillaries(this.model.datalayer, this.AncillariesConstants.DATALAYER_INFO.CLICK,
                this.AncillariesConstants.DATALAYER_INFO.ANADIR);
            if (name === 'requestPreorder') {
                this.DatalayerUtilsService.updateDatalayerEvents(
                    this.AncillariesConstants.DATALAYER_INFO.MODULE_PREORDER,
                    this.AncillariesConstants.DATALAYER_INFO.PREORDER_CODE,
                    this.AncillariesConstants.DATALAYER_INFO.PREORDER_DISPLAY);
                this.redirectToPreOrderLanding();
            } else {
                this.$scope.$emit(name);
            }
        }
    };

    redirectToPreOrderLanding () {
        //method to redirection to preorder
        const pnr = this.localStorageService.get('PNR');
        const surname = this.localStorageService.get('checkinSurname');
        const language = this.$rootScope.appLang;
        let lang = 'en';
        switch (language) {
                case 'ca':
                    lang = 'es';
                    break;
                case 'ja':
                case 'zh':
                case 'nl':
                case 'ru':
                    lang = 'en';
                    break;
                default:
                    lang = language;
                    break;
        }
        const toRedirect = `https://pre-order.iberia.com/landing/?locator=${pnr}&surname=${surname}&language=${lang}`;
        this.$window.open(toRedirect, '_blank');
    }

}


try {
    const mod = angular.module(componentInfo.module);
    ibAncillariesComponents.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibAncillariesComponents })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibAncillariesComponents.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibAncillariesComponents })
    );
}